import React, {useEffect, useState} from 'react';
import NavPanel from "../components/NavPanel";
import '../styles/Profile.css';
import {userCurrentGetApi, userCurrentPutApi} from "../http/userApi";
import {setResponseMessage} from "../utils/responseInform";
import PasswordToggleButton from "../components/PasswordToggleButton";


type UserType = {
    username: string,
    password?: string,
    firstName: string | null,
    lastName: string | null,
    middleName: string | null,
    phone: string | null,
    bookmarkColor?: string | null,
    bookmarkLabel?: string | null,
}

const DEFAULT_BOOKMARK_COLOR = '#f5a623';


const Profile = () => {
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [userData, setUserData] = useState<UserType | null>(null);
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    useEffect(() => {
        userCurrentGetApi()
            .then((response) => {
                if (response.data) {
                    setUserData(response.data)
                }
            }).catch((err) => {console.log(err)})
    }, []);

    const cancelEdit = () => {
        setIsEdit(false);
        setIsPasswordVisible(false);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!isEdit) return;

        const handle = handleSaveData(e);
        if (handle) {
            handle.then((response) => {
                if (response.response && response.response.status >= 400) {
                    setResponseMessage(`${response.response.data.message}`, 'error', 'errMsg')
                } else if (response.data) {
                    setUserData(response.data);
                    setIsEdit(false);
                    setIsPasswordVisible(false);
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    };

    return (
        <div className='profile page-content-container'>
            <NavPanel/>
            <div className='profile_body page_content_body'>
                <div className="profile__content-container contentWindow">
                    <div className="profile__data-header contentWindow__header">
                        <span className='contentWindow__name'>Профиль</span>
                    </div>
                    <div className="profile__data-nav contentWindow__nav">
                        {
                            isEdit ?
                                <div className='profile__nav-btns'>
                                    <button form='userForm' type='submit'
                                            className='nav__button btn-primary profile__save-button'>Сохранить</button>
                                    <button type='button' onClick={cancelEdit}
                                            className='nav__button btn-ghost profile__cancel-button'>Отмена</button>
                                </div>
                                :
                                <button className='profile__nav-button nav__button'
                                        disabled={!userData}
                                        onClick={() => { setIsEdit(true); setIsPasswordVisible(false); }}
                                >Редактировать</button>
                        }
                    </div>
                    <div className="profile__data-body-user-info contentWindow__body">
                        {
                            userData &&
                            profileForm({ userData, isEdit, isPasswordVisible, setIsPasswordVisible, onSubmit: handleSubmit })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};


// One layout for both modes — when not editing the same fields are just
// `disabled`. Keyed by mode so toggling remounts it and the uncontrolled
// inputs re-read `defaultValue` (so Cancel reverts, Save picks up new data).
function profileForm(params: {
    userData: UserType,
    isEdit: boolean,
    isPasswordVisible: boolean,
    setIsPasswordVisible: React.Dispatch<React.SetStateAction<boolean>>,
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void,
}) {
    const { userData, isEdit, isPasswordVisible, setIsPasswordVisible, onSubmit } = params;
    const ro = !isEdit;

    return (
        <form id='userForm' key={isEdit ? 'edit' : 'view'} className='profile__form' onSubmit={onSubmit}>
            <div className='field'>
                <label className='field__label' htmlFor='username'>Логин</label>
                <input id='username' name='username' type="text" placeholder='Логин*' required={true}
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.username}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='password'>Пароль</label>
                <div className='password-field'>
                    <input id='password' name='password' type={isPasswordVisible ? 'text' : 'password'}
                           placeholder='Пароль*' required={true}
                           className='input' maxLength={64} disabled={ro}
                           defaultValue='********'
                    />
                    {
                        isEdit &&
                        <PasswordToggleButton isVisible={isPasswordVisible}
                                              onToggle={() => setIsPasswordVisible(!isPasswordVisible)}/>
                    }
                </div>
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='firstName'>Имя</label>
                <input id='firstName' name='firstName' type="text" placeholder='Имя'
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.firstName !== null ? userData.firstName : ''}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='lastName'>Фамилия</label>
                <input id='lastName' name='lastName' type="text" placeholder='Фамилия'
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.lastName !== null ? userData.lastName : ''}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='middleName'>Отчество</label>
                <input id='middleName' name='middleName' type="text" placeholder='Отчество'
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.middleName !== null ? userData.middleName : ''}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='phone'>Телефон</label>
                <input id='phone' name='phone' type="text" placeholder='Телефон'
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.phone !== null ? userData.phone : ''}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='bookmarkColor'>Цвет закладки</label>
                <input id='bookmarkColor' name='bookmarkColor' type='color'
                       className='input profile__color-input' disabled={ro}
                       defaultValue={userData.bookmarkColor || DEFAULT_BOOKMARK_COLOR}
                />
            </div>
            <div className='field'>
                <label className='field__label' htmlFor='bookmarkLabel'>Подпись закладки</label>
                <input id='bookmarkLabel' name='bookmarkLabel' type='text' placeholder='Напр. «Важный клиент»'
                       className='input' maxLength={64} disabled={ro}
                       defaultValue={userData.bookmarkLabel || ''}
                />
            </div>
            <span id='errMsg' className='profile__err-field'></span>
        </form>
    )
}

function handleSaveData(event: any) {
    const { username, password, firstName, lastName, middleName, phone, bookmarkColor, bookmarkLabel } = event.target;

    if (password.value.length < 8) {
        setResponseMessage('Пароль должен быть больше 8 символов', 'error', 'errMsg')
        return
    }

    const newUserData: UserType = {
        username: username.value,
        password: password.value,
        firstName: firstName.value.length > 0 ? firstName.value : null,
        lastName: lastName.value.length > 0 ? lastName.value : null,
        middleName: middleName.value.length > 0 ? middleName.value : null,
        phone: phone.value.length > 0 ? phone.value : null,
        bookmarkColor: bookmarkColor.value || null,
        bookmarkLabel: bookmarkLabel.value.trim().length > 0 ? bookmarkLabel.value.trim() : null,
    }

    return userCurrentPutApi(newUserData);
}


export default Profile;
